import { useMemo } from 'react';
import { generateProjectWiseExplorerLink } from '@bentley/pw-link-ui';
import { readUniversalLinkParams } from '../searchParams/searchParams';

export function usePWELink(cannedConnection?: boolean): string {
  const { datasource, objectId, objectType, savedSearchId } =
    readUniversalLinkParams();

  const resourceType = useMemo((): string => {
    if (objectType?.toLowerCase() == 'doc') {
      return 'D';
    }
    return 'P';
  }, [objectType]);

  const pweLink = useMemo((): string => {
    if (!datasource || !objectId || savedSearchId || cannedConnection) {
      return '';
    }

    const pweLink = generateProjectWiseExplorerLink(
      datasource,
      resourceType,
      objectId
    );
    return pweLink;
  }, [cannedConnection, datasource, objectId, resourceType, savedSearchId]);

  return pweLink;
}
